import { IQTECHMAX_ASSETS_BASE_URL } from "./constants.js";
import { loadPageOnResolve } from "./script.js";

document.addEventListener("DOMContentLoaded", function () {
  const serviceCtas = document.querySelectorAll(".services-cta");

  const serviceContent = {
    ai: `  <h1 class="card-content-heading">AI Innovations</h1>

    <div class="section-grid">
  <section>
    <h4>AI Agents & Business Process Automation</h4>
    <ul>
      <li>Autonomous decision-making for business goals</li>
      <li>Workflow automation for complex and routine tasks</li>
      <li>Real-time data-driven actions and learning</li>
      <li>Integration with ERP, CRM, and enterprise systems</li>
      <li>Virtual assistants for reporting and customer service</li>
    </ul>
  </section>

  <section>
    <h4>Conversational AI & Natural Language Processing (NLP)</h4>
    <ul>
      <li>Chatbots with human-like, personalized responses</li>
      <li>Intent and sentiment analysis</li>
      <li>Speech recognition and dialog management</li>
      <li>Customer service automation and proactive engagement</li>
      <li>Continuous learning from conversations</li>
    </ul>
  </section>

  <section>
    <h4>Generative AI (Gen AI)</h4>
    <ul>
      <li>Automated content creation (text, images, audio, video)</li>
      <li>Synthetic data generation for healthcare and research</li>
      <li>Personalized recommendations and educational content</li>
      <li>Creative media production and marketing assets</li>
      <li>Code generation and software prototyping</li>
    </ul>
  </section>

  <section>
    <h4>Predictive AI</h4>
    <ul>
      <li>Demand forecasting and dynamic pricing</li>
      <li>Consumer behavior and churn prediction</li>
      <li>Fraud detection and prevention</li>
      <li>Preventive maintenance in manufacturing</li>
      <li>Real-time analytics and risk assessment</li>
    </ul>
  </section>

  <section>
    <h4>Computer Vision</h4>
    <ul>
      <li>Medical imaging and diagnostic analysis</li>
      <li>Quality control in manufacturing processes</li>
      <li>Facial recognition for security and access</li>
      <li>Automated checkout and inventory management</li>
      <li>Autonomous vehicle navigation and object detection</li>
    </ul>
  </section>

  <section>
    <h4>Data Analysis and Visualization</h4>
    <ul>
      <li>Interactive dashboards with Power BI, Tableau, Sisense</li>
      <li>Real-time trend spotting and reporting</li>
      <li>Automated chart generation and data storytelling</li>
      <li>Integration with cloud and business apps</li>
      <li>End-to-end analytics for informed decision-making</li>
    </ul>
  </section>
  </div>`,
    immersivetech: `<h1 class="card-content-heading">Immersive Innovations</h1>
 <div class="section-grid">
  <section>
    <h4>Augmented Reality (AR) Experiences</h4>
    <ul>
      <li>Virtual try-on and product preview placement</li>
      <li>Architecture and interior visualization</li>
      <li>Interactive user manuals and training</li>
      <li>AR/AI integrated communication platforms</li>
      <li>Social media filters and WebAR experiences</li>
    </ul>
  </section>

  <section>
    <h4>Virtual Reality (VR) Environments</h4>
    <ul>
      <li>Immersive training simulations</li>
      <li>Virtual property tours and real estate showcases</li>
      <li>Social VR for collaboration and events</li>
      <li>3D product demos and immersive marketing</li>
      <li>Multiplayer virtual workspaces with spatial audio</li>
    </ul>
  </section>

  <section>
    <h4>Digital Twin & Metaverse</h4>
    <ul>
      <li>Real-time digital replicas of physical assets</li>
      <li>Simulation and optimization of industrial processes</li>
      <li>Persistent shared 3D virtual worlds</li>
      <li>Spatial computing merging physical and digital realms</li>
      <li>Interaction among users and AI agents in virtual spaces</li>
    </ul>
  </section>
  </div>
`,
    appdev: `<h1 class="card-content-heading">Digital Transformation</h1>
 <div class="section-grid">
  <section>
    <h4>ERP/CRM Systems</h4>
    <p>
      Customized enterprise resource and client management solutions that streamline operations, enhance productivity, and improve customer relationship strategies.
    </p>
  </section>

  <section>
    <h4>Mobile App Development</h4>
    <p>
      User-centric applications built for iOS and Android platforms, focusing on intuitive interfaces, high performance, and cross-device compatibility.
    </p>
  </section>

  <section>
    <h4>Web App Development</h4>
    <p>
      Scalable, responsive web applications including e-commerce portals and SaaS platforms, engineered for speed, security, and reliability.
    </p>
  </section>

  <section>
    <h4>AI-Integrated Apps</h4>
    <p>
      Intelligent applications powered by Natural Language Processing (NLP), computer vision, and predictive analytics to automate and enhance decision-making.
    </p>
  </section>

  <section>
    <h4>Cross-Platform Desktop Apps</h4>
    <p>
      Unified desktop apps for Windows, Mac, and Linux using technologies like Electron and Flutter, ensuring consistent user experiences across operating systems.
    </p>
  </section>
</div>
`,
  };

  const industryImages = [
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/health_care.jpg`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/finace_and_banking.webp`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/ecommerce.jpg`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/logistics.png`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/education.jpg`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/aerospace_and_defence.jpg`,
  ];

  const industryCards = document.querySelectorAll(".industries-card");

  const loadIndustryImages = async () => {
    await Promise.all(industryImages.map((image) => fetch(image)));
    industryCards.forEach(
      (card, index) => (card.style.background = `url(${industryImages[index]})`)
    );
    document.getElementById("dynamicContent").innerHTML =
      serviceContent["ai"] || "<p>Content not available.</p>";

    let selectedServiceIndex = 0;
    serviceCtas.forEach((serviceCta, index) => {
      serviceCta.parentNode.addEventListener("click", () => {
        const service = serviceCta.getAttribute("data-service");

        serviceCtas[selectedServiceIndex].parentNode.classList.remove(
          "selected"
        );
        serviceCta.parentNode.classList.add("selected");
        selectedServiceIndex = index;

        const contentElement = document.getElementById("dynamicContent");

        contentElement.innerHTML =
          serviceContent[service] || "<p>Content not available.</p>";

        const mainContent = document.querySelector(".main-content");

        // 30% of the main-content's height
        const offset = mainContent.offsetHeight * 0.5;

        const y =
          contentElement.getBoundingClientRect().top +
          mainContent.scrollTop - // relative scroll inside main-content
          offset;

        mainContent.scrollTo({
          top: y,
          behavior: "smooth",
        });
      });
    });
  };

  loadPageOnResolve(loadIndustryImages);
});
